/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Limited_Purchase_PpInputs */

const en_limited_purchase_pp = /** @type {(inputs: Limited_Purchase_PpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Limit 1 per person`)
};

const ar_limited_purchase_pp = /** @type {(inputs: Limited_Purchase_PpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`حد أقصى 1 لكل شخص`)
};

const de_limited_purchase_pp = /** @type {(inputs: Limited_Purchase_PpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Limit: 1 pro Person`)
};

const es_limited_purchase_pp = /** @type {(inputs: Limited_Purchase_PpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Límite de 1 por persona`)
};

const fr_limited_purchase_pp = /** @type {(inputs: Limited_Purchase_PpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Limite de 1 par personne`)
};

const it_limited_purchase_pp = /** @type {(inputs: Limited_Purchase_PpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Limite di 1 a persona`)
};

const ja_limited_purchase_pp = /** @type {(inputs: Limited_Purchase_PpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`お一人様1回限り`)
};

const ko_limited_purchase_pp = /** @type {(inputs: Limited_Purchase_PpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`1인당 1회 제한`)
};

const pt_br_limited_purchase_pp = /** @type {(inputs: Limited_Purchase_PpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Limite de 1 por pessoa`)
};

const ru_limited_purchase_pp = /** @type {(inputs: Limited_Purchase_PpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ограничение: 1 на человека`)
};

const th_limited_purchase_pp = /** @type {(inputs: Limited_Purchase_PpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`จำกัด 1 ครั้งต่อคน`)
};

const tr_limited_purchase_pp = /** @type {(inputs: Limited_Purchase_PpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kişi başına 1 adetle sınırlıdır`)
};

const zh_cn_limited_purchase_pp = /** @type {(inputs: Limited_Purchase_PpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`每人限购一次`)
};

const zh_tw_limited_purchase_pp = /** @type {(inputs: Limited_Purchase_PpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`每人限購一次`)
};

/**
* | output |
* | --- |
* | "Limit 1 per person" |
*
* @param {Limited_Purchase_PpInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const limited_purchase_pp = /** @type {((inputs?: Limited_Purchase_PpInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Limited_Purchase_PpInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_limited_purchase_pp(inputs)
	if (locale === "ar") return ar_limited_purchase_pp(inputs)
	if (locale === "de") return de_limited_purchase_pp(inputs)
	if (locale === "es") return es_limited_purchase_pp(inputs)
	if (locale === "fr") return fr_limited_purchase_pp(inputs)
	if (locale === "it") return it_limited_purchase_pp(inputs)
	if (locale === "ja") return ja_limited_purchase_pp(inputs)
	if (locale === "ko") return ko_limited_purchase_pp(inputs)
	if (locale === "pt_br") return pt_br_limited_purchase_pp(inputs)
	if (locale === "ru") return ru_limited_purchase_pp(inputs)
	if (locale === "th") return th_limited_purchase_pp(inputs)
	if (locale === "tr") return tr_limited_purchase_pp(inputs)
	if (locale === "zh_cn") return zh_cn_limited_purchase_pp(inputs)
	return zh_tw_limited_purchase_pp(inputs)
});